<template>
  <div
    v-if="visible"
    class="holiday-doodle"
    :class="[
      `holiday-doodle--${doodle.tone || 'festive'}`,
      `holiday-doodle--${doodle.variant}`,
    ]"
  >
    <button
      class="holiday-doodle__trigger"
      type="button"
      :aria-label="doodle.title"
      :aria-expanded="String(open)"
      aria-describedby="holiday-doodle-tooltip"
      @click="open = !open"
      @keydown.esc="open = false"
      @blur="open = false"
    >
      <img
        class="holiday-doodle__art"
        :src="assetUrl"
        alt=""
        width="160"
        height="64"
        aria-hidden="true"
        draggable="false"
      />
    </button>
    <div
      id="holiday-doodle-tooltip"
      class="holiday-doodle__tooltip"
      :class="{ 'holiday-doodle__tooltip--open': open }"
      role="tooltip"
    >
      <strong>{{ doodle.title }}</strong>
      <span v-if="doodle.description">{{ doodle.description }}</span>
    </div>
  </div>
</template>

<script>
const DOODLE_ASSETS = Object.freeze({
  "knowledge-day": require("@/assets/holiday-doodles/knowledge-day.webp"),
  "educators-day": require("@/assets/holiday-doodles/educators-day.webp"),
  "saint-nicholas-day": require("@/assets/holiday-doodles/saint-nicholas-day.webp"),
  "winter-holiday": require("@/assets/holiday-doodles/winter-holiday.webp"),
  easter: require("@/assets/holiday-doodles/easter.webp"),
  "vyshyvanka-day": require("@/assets/holiday-doodles/vyshyvanka-day.webp"),
  "last-bell": require("@/assets/holiday-doodles/last-bell.webp"),
  "independence-day": require("@/assets/holiday-doodles/independence-day.webp"),
});

export default {
  name: "HolidayDoodle",
  data: () => ({ open: false }),
  computed: {
    doodle() {
      return this.$store.getters["ThemeStore/getConfig"]?.toolbarDoodle || {};
    },
    assetUrl() {
      return DOODLE_ASSETS[this.doodle.variant] || "";
    },
    visible() {
      return Boolean(
        this.doodle.enabled !== false && this.assetUrl && this.doodle.title
      );
    },
  },
};
</script>

<style lang="less" scoped>
.holiday-doodle {
  height: 64px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 190px;
  z-index: 1;
}

.holiday-doodle__trigger {
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0;
  width: 100%;
}

.holiday-doodle__trigger:focus-visible {
  border-radius: 12px;
  outline: 3px solid rgba(255, 255, 255, 0.72);
  outline-offset: 2px;
}

.holiday-doodle__art {
  display: block;
  height: 64px;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
  width: 160px;
}

.holiday-doodle__tooltip {
  background: #fff;
  border: 1px solid var(--theme-border-decorative);
  border-radius: 12px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.2);
  color: var(--text-primary);
  left: 50%;
  max-width: 280px;
  opacity: 0;
  padding: 11px 13px;
  pointer-events: none;
  position: absolute;
  top: calc(100% + 8px);
  transform: translate(-50%, -5px);
  transition: opacity 0.16s ease, transform 0.16s ease;
  visibility: hidden;
  width: max-content;
}

.holiday-doodle__tooltip strong,
.holiday-doodle__tooltip span {
  display: block;
}

.holiday-doodle__tooltip span {
  color: var(--text-secondary);
  font-size: 12px;
  line-height: 1.4;
  margin-top: 3px;
}

.holiday-doodle:hover .holiday-doodle__tooltip,
.holiday-doodle:focus-within .holiday-doodle__tooltip,
.holiday-doodle__tooltip--open {
  opacity: 1;
  transform: translate(-50%, 0);
  visibility: visible;
}

@media (max-width: 600px) {
  .holiday-doodle {
    transform: translate(-50%, -50%) scale(0.68);
  }

  .holiday-doodle__tooltip {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .holiday-doodle__tooltip {
    transition: none;
  }
}
</style>
